module.exports = __webpack_public_path__ + "img/status-icn_stopped@3x.890072c1.png";